module.exports = __webpack_public_path__ + "img/rcbig.de6f6026.png";